import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconCard: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.13333"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12.3333 4H3.66667C2.93029 4 2.33333 4.59695 2.33333 5.33333V10.6667C2.33333 11.403 2.93029 12 3.66667 12H12.3333C13.0697 12 13.6667 11.403 13.6667 10.6667V5.33333C13.6667 4.59695 13.0697 4 12.3333 4Z"
    />
    <path
      d="M2.33333 6.66667H13.6667"
    />
  </svg>
);

export {
  IconCard,
};
